import { z } from 'zod';
import { ProductDetailSlotsDTOTypes } from './ProductDetailSlotsTypes';

export const DeliveryInfosDTO = z.object({
    type: ProductDetailSlotsDTOTypes.deliveryAndReturnsInfosContent,
    details: z.object({
        items: z.array(
            z.object({
                name: z.string(),
                description: z.string(),
            }),
        ),
    }),
});

export const PaymentReinsuranceDTO = z.object({
    type: ProductDetailSlotsDTOTypes.paymentReinsurance,
    details: z.object({
        items: z.array(
            z.object({
                name: z.string(),
                image: z.object({
                    icon: z.string(),
                }),
                link: z.string().nullish(),
            }),
        ),
    }),
});

export const ProductDetailSlotDTO = z.union([DeliveryInfosDTO, PaymentReinsuranceDTO]);

export const ProductDetailSlotsDTO = z.object({
    slots: z.array(ProductDetailSlotDTO),
});

export const ProductDetailUnknownSlotsDTO = z.object({
    slots: z.array(z.unknown()),
});

export type PaymentReinsuranceDTO = z.infer<typeof PaymentReinsuranceDTO>;
export type DeliveryInfosDTO = z.infer<typeof DeliveryInfosDTO>;

export type ProductDetailSlotsDTO = z.infer<typeof ProductDetailSlotsDTO>;
